@use "@fukuri-admins/ui/layout" as *;

.wrapper {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
}

.title {
  @include typography("Jp/20_W6");
  margin: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: spacing("24");
}

.fields {
  display: flex;
  flex-direction: column;
  gap: spacing("16");
  width: 368px;
}

.actions {
  display: flex;
  gap: spacing("8");
}
